import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';
import React from 'react';

interface SubItemPopoverProps {
  key: string;
  title: string;
  children: React.ReactNode;
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const PREFIX = 'SubItemPopover';

const classes = {
  button: `${PREFIX}-button`,
  openButton: `${PREFIX}-open-button`,
  popover: `${PREFIX}-popover`
};

const Root = styled('div')(({ theme }) => ({
  width: '100%',
  [`& .${classes.button}`]: {
    width: '268px',
    backgroundColor: theme.palette.background.default
  },
  [`& .${classes.openButton}`]: {
    backgroundColor: theme.palette.background.paper + ' !important'
  }
}));

const SubItemPopover = ({ key, children, title, open, onOpen, onClose }: SubItemPopoverProps) => {
  const id = open ? key : undefined;

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const clikc = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    onOpen();
  };

  return (
    <Root>
      <Button
        className={classes.button + (open ? ' ' + classes.openButton : '')}
        disableElevation
        disableRipple
        aria-describedby={id}
        data-id={id}
        variant="outlined"
        onClick={clikc}
      >
        {title}
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </Button>
      <Popper
        // onResize={() => {}}
        // onResizeCapture={() => {}}
        id={id}
        open={open}
        disablePortal
        anchorEl={anchorEl}
        placement="bottom"
        modifiers={[
          {
            name: 'flip',
            enabled: false
          }
        ]}
      >
        <ClickAwayListener onClickAway={onClose}>
          <Paper
            sx={{
              width: '268px',
              backgroundColor: 'background.default',
              boxShadow: 'inset 0 7px 9px -7px rgba(0,0,0,0.4)'
            }}
          >
            {children}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Root>
  );
};

export default SubItemPopover;
